export default __webpack_public_path__ + "static/media/fridge1-after2.d2774721.jpg";